var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CContainer',[(_vm.$policy('wallet').view_any_or_group)?_c('CRow',[_c('CCol',{staticClass:"d-flex overflow-auto px-0",attrs:{"col":"12"}},[_c('InvFilterIt'),_c('InvSortIt',{staticClass:"mr-auto"})],1)],1):_vm._e(),_c('InvTable',{staticClass:"mt-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }